/** Create a promise and it's associated resolve and reject functions */
export const promisify = () => {
    let resolve;
    let resolved = false;
    let reject;
    const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
    }).then((result) => {
        resolved = true;
        return result;
    });
    return { promise, resolve, resolved, reject };
};
/** Same as setTimeout but async ;) */
export const timeout = (ms, timeIdRetriever) => {
    const { promise, resolve } = promisify();
    const timeId = setTimeout(resolve, ms);
    timeIdRetriever?.(timeId);
    return promise;
};
/** Same as requestAnimationFrame but async ;) */
export const raf = () => {
    const { promise, resolve } = promisify();
    requestAnimationFrame(resolve);
    return promise;
};
/** Poll until a check passes */
export const poll = (check, rate = 1000) => {
    const promisified = promisify();
    let timeout;
    let canceled = false;
    /** Clear timeout */
    const promise = promisified.promise;
    promise.cancel = () => {
        canceled = true;
        clearTimeout(timeout);
        promise.onCancel?.();
    };
    /** Trigger a function only if the action has not been canceled */
    const next = (fn) => {
        if (!canceled)
            fn();
    };
    /** Perform checks in a loop */
    const loop = async () => {
        try {
            if (await check()) {
                next(() => {
                    promisified.resolve();
                    promise.cancel();
                });
            }
            else {
                next(() => {
                    timeout = setTimeout(loop, rate);
                });
            }
        }
        catch (error) {
            next(() => {
                console.error(error);
                promisified.reject(error);
            });
        }
    };
    loop();
    return promise;
};
